export function wrapText(text, maxChar) {
  if (text == null) {
    return null;
  }
  return text.replace(
    new RegExp(`(?![^\<br\>]{1,${maxChar}}$)([^\<br\>]{1,${maxChar}})\\s`, "g"),
    "$1<br>"
  );
}

export function truncate(text, maxChar=30) {
  if (text == null)
      return "NA";
  return (text.length > maxChar) ? text.substr(0, maxChar-1) + '…' : text;
}

export function getDataColor(person) {
  if (person.GT == 0) {
    return "#15AA82";
  } else if (person.GT == 1) {
    return "#0B44DD";
  } else {
    return "#E42B3D";
  }
}

export function getString(text) {
  return text ? text : "NA";
}

export function hasPattern(pat, text) {
  text = text.toLowerCase();
  pat = pat.toLowerCase();
  let logics = "";
  let current = "";
  let i = 0;
  while (i < pat.length) {
    if ("(~|&)#".includes(pat[i])) {
      logics += pat[i];
      i += 1;
    }
    while (i < pat.length && !"(~|&)#".includes(pat[i])) {
      current += pat[i];
      i += 1;
    }
    current = current.trim();
    if (current != "") {
      if (logics[logics.length - 1] == "#") {
        let regex = new RegExp("\\b" + current + "\\b", "i");
        logics += regex.test(text) ? "1" : "0";
      } else {
        logics += text.indexOf(current) !== -1 ? "1" : "0";
      }
      current = "";
    }
  }
  logics = logics
    .replace(/\#/g, "")
    .replace(/\&/g, " && ")
    .replace(/\|/g, " || ")
    .replace(/\~/g, "! ");
  let result = true;
  try {
    result = !!eval(logics);
  } catch (err) {
    return "INVALID";
  }
  return result;
}